import axios from "axios";
import { useState } from "react";
import { Lock } from "lucide-react";
import { useAuth } from "context/useAuth";
import Button from "components/Button/Button";
import ViewMgtDevicePanel from "../ViewMgtDevicePanel";
import { FormInput } from "components/FormInput/FormInput";
import { useAppSettings } from "context/appsettingsContext";
import { isNullOrUndefined } from "functions/deviceStatusUtils";
import { errorAsync, successAsync } from "functions/notification";
import { includes } from "lodash";

export default function ViewMgtDeviceConfigAutoLock({ deviceId, configuration }: { deviceId?: string | null | undefined, device?: any | undefined | null, configuration?: any | undefined | null }) {

    const settings = useAppSettings();
    const { authorisedUser } = useAuth();
    const [updating, setUpdating] = useState<boolean>();
    const [delaySeconds, setDelaySeconds] = useState<string>();

    if (isNullOrUndefined(delaySeconds) && !isNullOrUndefined(configuration?.AutoLockConfiguration?.AutoLockDelaySeconds)) {
        setDelaySeconds(`${configuration?.AutoLockConfiguration?.AutoLockDelaySeconds}`);
    }

    function configIsValid() {

        const delaySecondsNum = Number(delaySeconds?.trim());

        if (isNaN(delaySecondsNum) || delaySecondsNum < 0 || delaySeconds?.includes('e') || delaySeconds?.includes('.')) {
            return false;
        }

        return true;
    }

    async function updateAsync() {
        try {
            setUpdating(true);
            await axios.post(
                settings.updateDeviceAutoLockUrl,
                { deviceId: deviceId, delaySeconds: Number(delaySeconds?.trim() || 0) },
                { headers: { Authorization: `Bearer ${authorisedUser.accessToken}` } }
            );
            successAsync('Auto-Lock updated');
        } catch(error: any) {
            errorAsync(`Failed to update Auto-Lock' : ${error?.response?.data?.message || error?.response?.data?.error || error?.message || error}`, error);
        } finally {
            setUpdating(false);
        }
    } 

    return (
        <ViewMgtDevicePanel title="Auto-Lock" icon={<Lock size={16} />} fullWidth collapsible collapsed>
            <div className="grid grid-cols-3 gap-4 p-2">
                <FormInput
                    type="number"
                    id="delaySeconds"
                    label="Delay (Seconds)"
                    value={delaySeconds}
                    onChange={(e) => setDelaySeconds(e.target.value)}
                    />
            </div>
           <div className="p-2">
                <Button
                    small
                    id='update'
                    onClick={updateAsync}
                    style={{minWidth:'100px'}}
                    disabled={updating || !configIsValid()}
                    label={updating ? 'Updating...' : 'Update'}
                    />
           </div>
        </ViewMgtDevicePanel>
    );
}